import script from "./AppDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./AppDialog.vue?vue&type=script&setup=true&lang=js"

import "./AppDialog.vue?vue&type=style&index=0&id=77aa02c2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77aa02c2"]])

export default __exports__